module.exports = __webpack_public_path__ + "static/media/wrl-charlotte-logo@2x.cf23f514.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-charlotte-logo@2x.png
// module id = 1212
// module chunks = 0